<template>
  <form>
    <div class="form-group">
      <label for="comment-text" class="control-label">Comment:</label>
      <textarea
        class="form-control"
        id="comment-text"
        v-model="comment"
      ></textarea>
    </div>

    <div class="row mb-4">
      <button
        @click="SaveComment()"
        type="button"
        class="
          btn btn-outline-success
          waves-effect waves-light
          col-12
          commentlefttasks
        "
      >
        Leave Comment
      </button>
    </div>
    <div class="form-group">
      <div v-for="(comment, index) in taskComments" :key="index">
        <div class="timeline-panel">
          <div class="timeline-heading">
            <h4 class="" style="font-size: 20px; font-weight: 800">
              {{ comment.userName }}
            </h4>
            <p style="margin-top: -10px">
              <small class="text-muted">
                <i class="fa fa-clock-o"></i>{{ comment.createdDateStr }}
              </small>
            </p>
          </div>
          <div class="timeline-body">
            <p>{{ comment.comment }}</p>
          </div>
        </div>
        <hr class="solid bg-white" />
      </div>
    </div>
  </form>
</template>
<script>
import axios from "axios";
import { createToast } from "mosha-vue-toastify";
import "mosha-vue-toastify/dist/style.css";
import Swal from "sweetalert2";
import { onUnmounted } from "@vue/runtime-core";
export default {
  name: "TaskTable",
  props: ["tableRefreash", "visitId", "patientTask"],
  setup() {},
  data() {
    return {
      TimerObject: null,
      visitTaskId: 0,
      comment: "",
      taskComments: [],
    };
  },
  methods: {
    callGetComment(id) {
      this.GetComment(id);
    },
    async GetComment(id) {
      var loader = this.$loading.show({
        // Optional parameters

        color: "#03a9f3",
      });
      this.comment = "";
      this.taskComments = [];
      this.visitTaskId = id;
      this.intDummyComm();
      const obj = {
        DC: this.dummyComm,
        VisitTaskId: this.visitTaskId,
      };
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Tasks/GetTaskComments",
        data: obj,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          res.data.status;
          const myData = res.data;
          if (myData.status == true) {
            this.taskComments = myData.data;
          } else {
            this.errorToast("Unable to undate information");
          }
        })
        .finally(() => {
          //this.tableRefreash();
          loader.hide();
        });
    },
    async SaveComment() {
      this.intDummyComm();
      this.dummyComm.visitId = this.patientTask.visitId;
      this.dummyComm.patientId = this.patientTask.patientId;
      const obj = {
        DC: this.dummyComm,
        VisitTaskId: this.visitTaskId,
        TaskId: this.patientTask.taskID,
        Comment: this.comment,
      };
      await axios({
        method: "post",
        url: this.SERVER + "/VNSPRAAPI/Tasks/InsertTaskComment",
        data: obj,
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((res) => {
          res.data.status;
          const myData = res.data;
          if (myData.status == true) {
            this.taskComments = myData.data;
          } else {
            this.errorToast("Unable to undate information");
          }
        })
        .finally(() => {
          this.GetComment(this.visitTaskId);
          this.tableRefreash();
        });
    },
    StartLogoutTime() {
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
    ResetLogoutTime() {
      clearTimeout(this.TimerObject);
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
  },
  mounted() {
    if (this.visitId !== undefined) {
      this.GetComment(this.visitId);
    }
  },
  unmounted() {
    this.tableRefreash();
  },
};
</script>